const OT = require("@opentok/client");
const { apiKey } = require("../config");

// Handling all of our errors here by alerting them

const handleError = error => {
  if (error) {
    console.log(error.message);
  }
};

export const initializeSession = (sessionId, token, setVolumeLevel) => {
  const session = OT.initSession(apiKey, sessionId);
  session.on("streamCreated", function(event) {
    console.log("stream created");
  });

  const publisherOptions = {
    showControls: false,
    videoSource: null,
    height: 0,
    width: 0
  };

  // Create a publisher
  const publisher = OT.initPublisher(
    "publisher",
    publisherOptions,
    handleError
  );

  publisher.on("audioLevelUpdated", function(event) {
    setVolumeLevel(event.audioLevel);
  });

  // Connect to the session
  session.connect(
    token,
    function(error) {
      // If the connection is successful, publish to
      // the session
      if (error) {
        handleError(error);
      } else {
        session.publish(publisher, handleError);
      }
    }
  );
  return publisher;
};

export const getMics = () => {
  return new Promise(resolve => {
    OT.getDevices(function(error, devices) {
      if (error) {
        console.log(error);
      }
      const mics = devices.filter(device => device.kind === "audioInput");
      resolve(mics);
    });
  });
};
